export default __webpack_public_path__ + "static/media/fastDelivery.b3f339d3.svg";